import type { Mapping } from '@milkdown/kit/prose/transform';

import type { ResolvedReviewSuggestionRange } from './types';

/**
 * Forward-map resolved ranges through a transaction's mapping.
 *
 * Doomed text is immutable (blocked in filterTransaction), so ranges only need
 * positional mapping and never content-based restoration.
 */
export function mapRanges(ranges: ResolvedReviewSuggestionRange[], mapping: Mapping): ResolvedReviewSuggestionRange[] {
  const mapped: ResolvedReviewSuggestionRange[] = [];

  for (const range of ranges) {
    if (range.opType === 'insert') {
      const pos = mapping.map(range.from, 1);
      mapped.push({ ...range, from: pos, to: pos });
      continue;
    }

    const from = mapping.map(range.from, 1);
    const to = mapping.map(range.to, -1);
    mapped.push({ ...range, from, to });
  }

  return mapped;
}
